import { useAlert } from 'components/alert'

import { RequisicaoExameModal, RequisicaoExameModalStep } from '../RequisicaoExameModal'
import { MamografiaAnamneseModalStep } from './MamografiaAnamneseModalStep'
import { MamografiaDadosExameModalStep } from './MamografiaDadosExameModalStep'
import { MamografiaIndicacaoClinicaModalStep } from './MamografiaIndicacaoClinicaModalStep'
import {
  mamografiaAnamneseValidator,
  mamografiaDadosExameValidator,
  mamografiaIndicacaoClinicaValidator,
} from './validator-mamografia'

interface RequisicaoExameMamografiaModalProps {
  onClose: () => void
}

const steps: RequisicaoExameModalStep<any>[] = [
  { title: 'Anamnese', render: () => <MamografiaAnamneseModalStep />, validator: mamografiaAnamneseValidator },
  {
    title: 'Indicação clínica',
    render: () => <MamografiaIndicacaoClinicaModalStep />,
    validator: mamografiaIndicacaoClinicaValidator,
  },
  {
    title: 'Dados do exame',
    render: () => <MamografiaDadosExameModalStep />,
    validator: mamografiaDadosExameValidator,
  },
]

export function RequisicaoExameMamografiaModal(props: Readonly<RequisicaoExameMamografiaModalProps>) {
  const { onClose } = props
  const alert = useAlert()

  const handleSubmit = () => {
    alert('success', 'Requisição de exame de mamografia salva com sucesso')
    onClose()
  }

  return (
    <RequisicaoExameModal<any>
      title='Requisição de exame de mamografia'
      steps={steps}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  )
}
